import { useState, useEffect } from 'react'
import i18next from 'i18next'
import { useTranslation } from 'react-i18next'

export const i18nConfig = {
  namespaces: [] as string[],
}

export function useLocale() {
  const [locale, setLocale] = useState<string>(i18next.language)

  // event subscription
  useEffect(() => {
    const handleLanguageChanged = (lng: string) => {
      setLocale(lng)
    }

    i18next.on('languageChanged', handleLanguageChanged)

    return () => {
      i18next.off('languageChanged', handleLanguageChanged)
    }
  }, [])

  return locale
}

// for internal usage in fe-ui components
export function useTranslatedText(key?: string) {
  const { namespace, key: actualKey } = getNamespace(key)
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  const { t } = useTranslation(namespace as any) // compilation error: type string is not assignable to type shared | platform
  if (!actualKey) return ''
  // @ts-ignore
  const result = t(actualKey[0]?.toLowerCase() + actualKey.slice(1))
  if (typeof result === 'string') return result
  return actualKey.split('.').at(-1) ?? ''
}

// i18key can contain namespace:key or just key for default namespace (shared)
// when an error message requires variable substitution, the key will be translated error message that contains `:`
function getNamespace(key?: string) {
  if (!key) return { namespace: undefined, key: undefined }
  if (key.includes(':')) {
    const [namespace, actualKey] = key.split(':')
    if (i18nConfig.namespaces.includes(namespace)) return { namespace, key: actualKey }
    return { namespace: undefined, key }
  }
  return { namespace: undefined, key }
}
